module.exports = __webpack_public_path__ + "img/home.9131ba3b.jpg";